import { ActionType } from "../action-types";
import { Action } from "../actions";

export type NotificationVariantType =
  | "error"
  | "neutral"
  | "success"
  | "warning";
export type NotificationsType = {
  id?: number;
  message: string;
  variant: NotificationVariantType;
  dismissAfter: number;
}[];

const reducer = (
  state: NotificationsType = [],
  action: Action
): NotificationsType => {
  switch (action.type) {
    case ActionType.ADD_NOTIFICATIONS: {
      // Deduplicate: skip notifications whose message already exists in state
      const existingMessages = new Set(state.map((n) => n.message));
      const unique = action.payload.filter(
        (n) => !existingMessages.has(n.message)
      );
      if (unique.length === 0) return state;
      return [...state, ...unique];
    }
    case ActionType.REMOVE_NOTIFICATIONS: {
      const removeCount = action.payload;
      if (removeCount + 1 > state.length) {
        return [];
      }
      return state.slice(removeCount, state.length);
    }
    default:
      return state;
  }
};

export default reducer;
